import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M17.296 13.715c-1.806-2.558-1.017-4.738.96-3.536 1.19.723-4.744 5.95-4.744 5.95s-4.185 1.512-4.162 1.3c.023-.21 1.018-4.259 1.018-4.259s5.682-7.129 6.585-6.55c.904.578 2.79 2.513 3.122 2.29s2.044-1.8 1.53-2.29c-.515-.49-2.619-2.514-2.928-2.47-.308.056-.983.835-.983.835"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M14.66 3.2H4.267A1.06 1.06 0 0 0 3.2 4.257v14.414c0 .84.684 1.529 1.543 1.529h10.972a1.48 1.48 0 0 0 1.485-1.38"
    />
  </svg>
);
export const DiaryIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
